(ns ycweb.app.website.auth.login
  (:require
   [cemerick.url :as url]
   [rum.core :as rum]
   [ycweb.app.website.auth.common :as auth.cmn]
   [ycweb.app.website.common.facebook :as fb]
   [ycweb.app.website.website :as website]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.hash :as hash]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.components.feedback :as feedback]))

(rum/defc auth-start-modal < rum/reactive [app-atom config _]
  (let [feedback-msg (cmn/curact config [:config :feedback-msg])
        feedback-info (cmn/curact config [:config :feedback-info])]
    [:<>
     [:div.modal__header
      (headings/heading "Log in to Yuppiechef" {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      (when feedback-info
        (feedback/feedback
          :info feedback-info
          [feedback-msg]))
      [:div.form-field
       (buttons/button-web "Log in with email"
         {:type  :button
          :on-click
          #(do
             (grid/close-modal app-atom)
             (grid/open-modal app-atom :web.login/login-with-email
               {:config
                {:size :small
                 :blur-bg? true
                 :form? true}}))
          :style :primary
          :size :default
          :full true
          :icon :email})]
      ;; These buttons will be added during auth phase 2
      #_[:div.form-field
         (buttons/button-web "Continue with Google"
           {:type  :button
            :style :secondary
            :size  :default
            :full  true
            :icon  :google-g-colour})]
      [:div.form-field
       (buttons/button-web "Continue with Facebook"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :web.login/login-by-facebook {})
          :style :facebook
          :size :default
          :full true
          :icon :facebook})]
      #_[:div.form-field
         (buttons/button-web "Continue with Apple ID"
           {:type  :button
            :style :secondary
            :size  :default
            :full  true
            :icon  :apple})]
      [:hr {:class (u/bem :u-hr [:or])}]
      (headings/heading "New to Yuppiechef?" {:type :h3 :size :small})
      [:div.form-field
       (buttons/button-web "Create an account"
         (merge
           (urlstate/href-props app-atom "login" "register" (auth.cmn/redirect-params app-atom))
           {:type :button
            :style :secondary
            :size :default
            :icon :user
            :full true}))]

      [:p.yc-paragraph
       [:a
        (merge
          (urlstate/href-props app-atom "help" "article" {:id 153 :name "Creating-a-Yuppiechef-Account"})
          {:class (u/bem :text-link [:muted])})
        "Creating an account"]
       " is free, quick and easy."]]
     (toaster/loading-overlay app-atom :web.login/user-login)]))

(defmethod grid/modal-config :web.login/login-start [_ _ _]
  {:body-raw auth-start-modal
   :modal-type :variable
   :size :small})

(defmethod flow/render-screen :web.login [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "")
    {}))

(defmethod comms/receive :web.auth/initiate [app-atom {:keys [facebook]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :facebook facebook)))

(defmethod t/transition-open :web.login [app-atom _ _]
  (comms/ajax-get :web.auth/initiate {})
  (when (nil? (:user @app-atom))
    (grid/open-modal app-atom
      :web.login/login-start
      {:config
       {:size :small
        :blur-bg? true}})))

(defmethod t/transition-after-open :web.login [app-atom _ _]
  (let  [process-atom (cmn/process-cursor app-atom)
         facebook-atom (rum/cursor process-atom :facebook)]
    (fb/load-sdk
      #(fb/init
         {:appId (:login-app-id @facebook-atom)
          :status true
          :cookies true
          :xfbml true
          :version "v16.0"}))))

(defn validate-login-pass [password errors]
  (let [current-errors
        [(when
           (not (u/presence password))
           "Please enter a password")]]
    (assoc errors :user/password current-errors)))

(defn validate-user-input [{:user/keys [email password]}]
  (let [errors
        (->>
          {}
          (auth.cmn/validate-email email)
          (validate-login-pass password))]
    (cond
      (empty? (remove nil? (mapcat second errors)))
      {:success true}

      :else
      {:success false :errors errors})))

(defmethod grid/action :web.login/login-by-email
  [app-atom {:session/keys [php-session-id]
             :keys [user captcha-token after-login-redirect]}]
  (let [process-atom (cmn/process-cursor app-atom)
        login-atom (rum/cursor process-atom :login)
        login-data (auth.cmn/yc-input-get-form-values login-atom)
        form-data
        (assoc login-data
          :user/password
          (when
            (u/presence (:user/password login-data))
            (:user/password login-data)))

        validation (validate-user-input form-data)]

    (cond
      (:success validation)
      (comms/ajax-post :web.auth/login
        {:user
         #:user
          {:email (:user/email user)
           :password (:user/password user)
           :auto-login? (:user/auto-login? user)}
         :session/php-session-id php-session-id
         :captcha-token captcha-token
         :after-login-redirect after-login-redirect})

      :else
      (do
        (toaster/close-overlay app-atom :web.login/user-login)
        (auth.cmn/display-input-errors process-atom (:errors validation) :login)))))

;; ========== AUTH EMAIL ==========
(defn submit-auth-form [app-atom captcha-site-key after-login-redirect]
  (let [process-atom (cmn/process-cursor app-atom)
        login-atom (rum/cursor process-atom :login)
        email 
        (or
          (get-in @login-atom [:user/email :value])
          ;; The below is in order to work around a quirk of google's autosubmission
          ;; The form submits before firing any of the onchanges that power our atoms
          ;; As a result the atom is null, and it manages to bypass the javascript validation as a result
          ;; Validation still occurs on the server side so I deem this a valid workaround. -rob
          #?(:cljs
             (.-value
               (first
                 (.getElementsByName js/document "email")))))

        password
        (or
          (get-in @login-atom [:user/password :value])
          #?(:cljs
             (.-value
               (first
                 (.getElementsByName js/document "password")))))]
    (toaster/open-overlay app-atom :web.login/user-login)
    
    (appcommon/recaptcha app-atom captcha-site-key
      :web.login/login-by-email
      {:after-login-redirect after-login-redirect
       :session/php-session-id (get @app-atom :php-session-id)
       :user
       #:user
        {:email email
         :password (when (u/presence password) (hash/md5 password))
         :auto-login? (cmn/curact process-atom [:auto-login-checkbox :value])}}
      ;; No token: the overlay above would otherwise never close
      (fn []
        (toaster/close-overlay app-atom :web.login/user-login)
        (toaster/open-toast app-atom :error appcommon/recaptcha-failure-msg
          {:show-close-button true})))))

(rum/defc auth-email-modal-body < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        login-atom (cmn/cursor-in process-atom [:login])
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)
        after-login-redirect (:afterloginredirect (cmn/screen-params app-atom))
        opts
        {:on-key-down
         (fn [e _]
           (when
             (and (not (.-shiftKey e)) (== (.-keyCode e) 13))
             (submit-auth-form app-atom captcha-site-key after-login-redirect)
             (.preventDefault e)))}]
    [:<>
     [:div.modal__header
      (headings/heading "Log in with email" {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      (forms/input "Email address: (required)" "e.g. jane@domain.com"
        (rum/cursor-in login-atom [:user/email])
        (merge
          {:type :email
           :name "email"
           :required? true
           :icon? true
           :autocomplete "on"
           :yc-input? true}
          opts))
      (forms/password-input "Password: (required)" ""
        (rum/cursor-in login-atom [:user/password])
        (merge 
          {:yc-input? true
           :name "password"} 
          opts))
      [:div.form-field
       (forms/checkbox "Keep me logged in for 30 days"
         (rum/cursor-in process-atom [:auto-login-checkbox])
         {:yc-input? true
          :default-checked true})]
      [:p
       {:class (u/bem :yc-paragraph [:flush])}
       [:a.text-link
        (urlstate/href-props app-atom "login" "forgotpassword" (auth.cmn/redirect-params app-atom))
        "Forgot password?"]
       [:span.u-pipe " | "]
       [:a.text-link
        (urlstate/href-props app-atom "login" "register" (auth.cmn/redirect-params app-atom))
        "New? Create account."]]
      [:hr {:class (u/bem :u-hr [:or])}]
      (headings/heading "New to Yuppiechef?" {:type :h3 :size :small})
      [:p.yc-paragraph
       [:a.text-link
        (urlstate/href-props app-atom "help" "article"
          {:name "Creating-a-Yuppiechef-Account"
           :id 153})
        "Create an account"]
       ". It's free, quick and easy."]]
     (toaster/loading-overlay app-atom :web.login/user-login)]))

(rum/defc auth-email-modal-footer < rum/reactive cmn/cursors [app-atom]
  (let [{:keys [captcha-site-key]} (cmn/curact app-atom :config)
        after-login-redirect (:afterloginredirect (cmn/screen-params app-atom))]
    [:div
     (grid/button-row
       {:left-text "Back"
        :left-fn
        #(do
           (grid/close-modal app-atom)
           (grid/open-modal app-atom :web.login/login-start
             {:config
              {:size :small
               :blur-bg? true}}))
        :right-text "Log in"
        :right-fn
        #(submit-auth-form app-atom captcha-site-key after-login-redirect)})]))

(defmethod grid/modal-config :web.login/login-with-email [_ _ _]
  {:body-raw auth-email-modal-body
   :footer auth-email-modal-footer
   :modal-type :variable})

(defmethod comms/receive :web.auth/login [app-atom e]
  (when (u/presence (:action e))
    (grid/dispatch-action app-atom (:action e) {:payload (:payload e)})))

(defmethod grid/action :redirect [app-atom config _]
  (urlstate/raw-redirect app-atom (:payload config)))

(defmethod grid/action :web.login/login-by-facebook [app-atom {:keys []}]
  (toaster/open-overlay app-atom :web.login/user-login)
  (fb/get-login-status
    (fn [status-response]
      (case (:status status-response)
        "connected"
        (comms/ajax-post :web.auth/facebook.login
          (assoc status-response
            :session/php-session-id (get @app-atom :php-session-id)))

        ;; else
        (fb/login
          (fn [login-response]
            (cond
              (= (:status login-response) "connected")
              (comms/ajax-post :web.auth/facebook.login
                (assoc login-response
                  :session/php-session-id (get @app-atom :php-session-id)))

              (= (:status login-response) "not_authorized")
              (do
                (toaster/close-overlay app-atom :web.login/user-login)
                (toaster/open-toast app-atom :error "An error occurred" {}))

              :else
              (toaster/close-overlay app-atom :web.login/user-login)))
          {:scope "public_profile,email,user_gender,user_birthday"})))))

(defmethod comms/receive :web.auth/facebook.login [app-atom {:keys [action errors payload]}]
  (cond
    errors
    (do
      (toaster/close-overlay app-atom :web.login/user-login)
      (toaster/open-toast app-atom :error "An error occurred" {}))

    :else
    (grid/dispatch-action app-atom action {:payload payload})))

(rum/defc auth-combo-not-found-modal-body < rum/reactive [app-atom]
  [:<>
   [:div.modal__header
    (headings/heading "Email / Password combination not found" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph
     [:b
      "We couldn't match the email address and password you entered."]]
    [:p.yc-paragraph
     "Would you like to "
     [:a.text-link
      (urlstate/href-props app-atom "login" "forgotpassword" (auth.cmn/redirect-params app-atom))
      "reset your password"]
     " or "
     [:a.text-link
      (urlstate/href-on-click
        #(do
           (grid/close-modal app-atom)
           (grid/open-modal app-atom :web.login/login-with-email
             {:config
              {:size :small
               :blur-bg? true}})))
      "try logging in again?"]
     " Pssst, check your spelling — might be that too. Else you can "
     [:a.text-link
      (urlstate/href-on-click
        #(do
           (grid/close-modal app-atom)
           (urlstate/redirect app-atom "login" "register" (auth.cmn/redirect-params app-atom))))
      "create an account."]]]])

(rum/defc auth-combo-not-found-modal-footer < rum/reactive [app-atom]
  [:div
   (grid/button-row
     {:left-text "Reset password"
      :left-no-icon true
      :left-fn
      #(do
         (grid/close-modal app-atom)
         (urlstate/redirect app-atom "login" "forgotpassword" (auth.cmn/redirect-params app-atom)))
      :right-text "Try again"
      :right-fn
      #(do
         (grid/close-modal app-atom)
         (grid/open-modal app-atom :web.login/login-with-email
           {:config
            {:size :small
             :blur-bg? true}}))})])

(defmethod grid/modal-config :web.login/login-combo-not-found [_ _ _]
  {:body-raw auth-combo-not-found-modal-body
   :footer auth-combo-not-found-modal-footer
   :modal-type :variable})

(defmethod grid/action :login/invalid [app-atom _ _]
  (toaster/close-overlay app-atom :web.login/user-login)
  (grid/open-modal app-atom :web.login/login-combo-not-found
    {:config
     {:size :small
      :blur-bg? true}}))

(rum/defc auth-account-not-found-modal-body < rum/reactive [app-atom]
  [:<>
   [:div.modal__header
    (headings/heading "Account not found" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph
     [:b "We couldn't find an account using that email address in our system."]]
    [:p.yc-paragraph
     "It looks like you haven't registered with us yet. Would you like to "
     [:a.text-link
      (urlstate/href-on-click
        #(do
           (grid/close-modal app-atom)
           (urlstate/redirect app-atom "login" "register" (auth.cmn/redirect-params app-atom))))
      "create an account?"]
     " Or "
     [:a.text-link
      (urlstate/href-on-click
        #(do
           (grid/close-modal app-atom)
           (grid/open-modal app-atom :web.login/login-start
             {:config
              {:size :small
               :blur-bg? true}})))
      "try logging in again"]
     ". Pssst, check your spelling — might be that too."]]])

(rum/defc auth-account-not-found-modal-footer < rum/reactive [app-atom]
  [:div
   (grid/button-row
     {:left-text "Try again"
      :left-fn
      #(do
         (grid/close-modal app-atom)
         (grid/open-modal app-atom :web.login/login-start
           {:config
            {:size :small
             :blur-bg? true}}))
      :right-text "Create account"
      :right-fn
      #(do
         (grid/close-modal app-atom)
         (urlstate/redirect app-atom "login" "register" (auth.cmn/redirect-params app-atom)))})])

(defmethod grid/modal-config :web.login/login-account-not-found [_ _ _]
  {:body-raw auth-account-not-found-modal-body
   :footer auth-account-not-found-modal-footer
   :modal-type :variable})

(defmethod grid/action :login/no-email [app-atom _ _]
  (toaster/close-overlay app-atom :web.login/user-login)
  (grid/open-modal app-atom :web.login/login-account-not-found
    {:config
     {:size :small
      :blur-bg? true}}))

(defmethod flow/render-screen :web.login/logoff [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/generic-loading-screen)
    {}))

(defmethod t/transition-open :web.login/logoff [app-atom _ _]
  (toaster/open-toast app-atom :processing "Logging Out" {}))

(defmethod t/transition-after-open :web.login/logoff [app-atom _ _]
  (let [screen-params (cmn/screen-params app-atom)]
    (comms/ajax-get :web.auth/logoff
      {:goto
       (when (:goto screen-params)
         (url/url-decode (:goto screen-params)))})))

(defmethod comms/receive :web.auth/logoff [app-atom {:keys [goto]}]
  (cond
    goto
    (urlstate/raw-redirect app-atom goto)

    :else
    (urlstate/redirect app-atom "index")))

(rum/defc auth-forgot-password-modal-body < rum/reactive [app-atom _ _]
  (let [action-atom (cmn/action-cursor app-atom)]
    [:<>
     [:div.modal__header
      (headings/heading "Reset your password"
        {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      [:p.yc-paragraph
       "Fill in your email address below and we'll send you a link to create a new password for your Yuppiechef account."]
      (forms/input "Email address: (required)" "e.g. jane@domain.com"
        (rum/cursor-in action-atom [:forgot :user/email])
        {:type :email
         :icon? true
         :yc-input? true})]
     (toaster/loading-overlay app-atom :web.login/password-reset)]))

(defmethod grid/action :web.login/forgot [_app-atom config _]
  (comms/ajax-post :web.auth/forgot config))

(defmethod comms/receive :web.auth/forgot [app-atom e]
  (toaster/close-overlay app-atom :web.login/password-reset)
  (when (:success e)
    (urlstate/redirect app-atom "login" "forgotpasswordsent")))

(defn validate-forgot-password [{:user/keys [email]}]
  (let [errors (auth.cmn/validate-email email {})]
    (cond
      (empty? (remove nil? (mapcat second errors)))
      {:success true}

      :else
      {:success false :errors errors})))


(defmethod grid/action :web.login/forgot-validation [app-atom _]
  (let [action-atom (cmn/action-cursor app-atom)
        forgot-atom (rum/cursor action-atom :forgot)
        forgot-data (auth.cmn/yc-input-get-form-values forgot-atom)
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)
        validation (validate-forgot-password forgot-data)]

    (cond
      (not (:success validation))
      (auth.cmn/display-input-errors action-atom (:errors validation) :forgot)

      :else
      (do
        (toaster/open-overlay app-atom :web.login/password-reset)
        (appcommon/recaptcha app-atom captcha-site-key
          :web.login/forgot
          (u/maybe assoc
            {:email @(rum/cursor-in action-atom [:forgot :user/email :value])}
            :after-login-redirect (:afterloginredirect (auth.cmn/redirect-params app-atom)))
          ;; No token: the overlay above would otherwise never close
          (fn []
            (toaster/close-overlay app-atom :web.login/password-reset)
            (toaster/open-toast app-atom :error appcommon/recaptcha-failure-msg
              {:show-close-button true})))))))

(rum/defc auth-forgot-password-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "Back"
      :left-fn #(grid/dispatch-action app-atom :auth-modal-close {})
      :right-text "Send reset link"
      :right-fn #(grid/dispatch-action app-atom :web.login/forgot-validation {})})])

(defmethod grid/action :auth-modal-close [app-atom _ _]
  (urlstate/redirect app-atom "login"))

(defmethod grid/modal-config :web.login/forgot-password [_ _ _]
  {:body-raw auth-forgot-password-modal-body
   :footer auth-forgot-password-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

(defmethod flow/render-screen :web.login/forgotpassword [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "forgotpassword")
    {}))

(defmethod t/transition-open :web.login/forgotpassword [app-atom _ _]
  (let [action-atom (cmn/action-cursor app-atom)
        forgot-atom (rum/cursor-in action-atom [:forgot :user/email :value])
        screen-params (cmn/screen-params app-atom)
        email (:e screen-params)]
    (when
      (u/presence email)
      (reset! forgot-atom
        (hash/base64-decode
          (url/url-decode email))))
    (grid/open-modal app-atom
      :web.login/forgot-password
      {:config
       {:size :small
        :blur-bg? true}})))

(defmethod flow/render-screen :web.login/forgotpasswordsent [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "forgotpasswordsent")
    {}))

(defmethod t/transition-open :web.login/forgotpasswordsent [app-atom _ _]
  (grid/open-modal app-atom
    :web.login/forgot-password-sent
    {:config
     {:size :small
      :blur-bg? true}}))

;; ========== AUTH FORGOT PASSWORD SENT ==========
(rum/defc auth-forgot-password-sent-modal-body < rum/reactive [_app-atom _ _]
  [:<>
   [:div.modal__header
    (headings/heading "Password reset link sent" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph
     [:b
      "We've sent you an email containing a link to create a new password."]]
    [:p.yc-paragraph
     "Please check your inbox. If it doesn't arrive shortly, please check your spam folder or "
     "try sending it again."]]])

(rum/defc auth-forgot-password-sent-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "Try again"
      :left-no-icon true 
      :left-fn #(urlstate/redirect app-atom "login" "forgotpassword")
      :right-text "Got it"
      :right-no-icon true
      :right-fn #(urlstate/redirect app-atom "login")})])

(defmethod grid/modal-config :web.login/forgot-password-sent [_ _ _]
  {:body-raw auth-forgot-password-sent-modal-body
   :footer auth-forgot-password-sent-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

;;REDIRECTS
(defmethod flow/render-screen :web.login/createPasswordAction [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/generic-loading-screen)
    {}))

(defmethod t/transition-after-open :web.login/createPasswordAction [app-atom _]
  (urlstate/redirect app-atom "login" "cp"))

(defmethod flow/render-screen :web.login/login [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/generic-loading-screen)
    {}))

(defmethod t/transition-after-open :web.login/login [app-atom _]
  (urlstate/redirect app-atom "login"))